import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { googleMapKey } from 'dp-formio';
import { Observable } from 'rxjs';

declare var $: any;
@Injectable({ providedIn: 'root' })
export class GeoLocationService {

    coordinates: any;
    lastWatchPosition: number;

    constructor(private http: HttpClient) { }

    getPosition(): Observable<any> {
        return new Observable(
            (observer) => {
                if (this.lastWatchPosition) {
                    navigator.geolocation.clearWatch(this.lastWatchPosition);
                    this.lastWatchPosition = null;
                }
                this.lastWatchPosition = navigator.geolocation.watchPosition((pos: any) => {
                    observer.next(pos);
                    if (pos) observer.complete();
                }),
                    () => {
                        console.log('Position is not available');
                    },
                {
                    enableHighAccuracy: false
                };
            });
    }

    getReverseGeocodingData(lat, lng, locale: "ar" | "en") {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'GET',
                url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&language=${locale}&key=${googleMapKey}`,
                success: function (data) {
                    if (data.status == google.maps.GeocoderStatus.OK) {
                        resolve(data.results[0].formatted_address);
                    }
                    else {
                        console.log(data);
                        resolve('');
                    }
                }
            });
        });
    }
}
